import { render, staticRenderFns } from "./ModerationDetail.vue?vue&type=template&id=eaccdb10"
import script from "./ModerationDetail.vue?vue&type=script&lang=js"
export * from "./ModerationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports